<div class="wrapper-pages">
    <router-outlet></router-outlet>
    <app-footer *ngIf="activePageHelper.activePage?.showFooter && authenticationHelperService.isAuthenticated"></app-footer>
</div>
<div class="wrapper-screen-size-page">
  <div class="content-screen-size-page">
    <img class="logo-screen-size" src="../assets/icons/logo-horizontal-yellow.svg" alt="">
    <div class="content-screen-size">
      <img class="screen-illustration" src="../assets/images/screen-size-icon.svg" alt="">
      <span class="title-text-screen">{{'NEW_TEXT.this_screen_size_is_not_supported_yet' | translate}}.</span>
      <span class="subtitle-text-screen">{{'NEW_TEXT.please_download_thelysts_mobile_app_for_the_full_mobile_experience' | translate}}.</span>
      <div class="wrapper-btn-store">
        <a href="https://apps.apple.com/us/app/thelysts/id6661027814">
          <img src="../assets/images/btn-app-store.png" alt="">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.thelysts.app">
          <img src="../assets/images/btn-play-store.png" alt="">
        </a>
      </div>
    </div>
  </div>
</div>
